import { createRequest } from "helpers/tools";

export const getSourceTest = async (id) => {
    return await createRequest({
        suffix: `sources/file-jobs/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
